<template>
  <div class="w-full">
    <FilterParameter
      v-for="parameter in typeParameters"
      :key="parameter.idParameter"
      :parameter="parameter"
      query-code="t"
      :is-detail="isDetail"
    />
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import { useEnumStore } from '@stores/enum';
import FilterParameter from "@components/filter/filter-parameter";

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  isDetail: {
    type: Boolean,
    default: false
  }
});

const enums = useEnumStore();
const parameters = ref([]);

const typeParameters = computed(() => _.filter(parameters.value, item => _.includes(item.types, props.type)));

const reload = (items) => {
  parameters.value = setupContentParameters(items);
}

onMounted(() => reload(enums.contentParameters));

watch(() => enums.contentParameters, (items) => reload(items));

</script>
